export const snakeCase = (str) => {
  if (!str) return "";
  let massagedString = str.toLowerCase();
  let replace = (mStr) => {
    if (mStr.indexOf(" ") > -1) {
      let cleanerString = mStr.replace(" ", "_");
      return replace(cleanerString);
    } else {
      return mStr;
    }
  };
  return replace(massagedString);
};

export const convertTextToHTML = (text) => {
  //Returns string instead of JSX so previewer can render
  return (
    `<div style="font-family: monospace; font-size: 12px;">` +
    encodeHtmlEntities(text).replace("\n", "<br>") +
    `</div>`
  );
};

export const humanReadableSize = (size) => {
  let unit = "KB";
  let hrSize = size / 1024.0;

  if (hrSize >= 1024) {
    hrSize = hrSize / 1024.0;
    unit = "MB";

    if (hrSize >= 1024) {
      hrSize = hrSize / 1024.0;
      unit = "GB";
    }
  }

  // Perform rounding. We want the ceil so we don't show something like "You
  // attempted to upload 14.00MB and the max is 14.00MB".

  let hrSizeRounded = Math.ceil(hrSize * 100.0) / 100.0;

  return `${hrSizeRounded.toFixed(2)} ${unit}`;
};
